// import $ from 'jquery';
// import Swiper from 'swiper/bundle'; 
// import 'swiper/css';
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger'
// import * as THREE from 'three';
// gsap scrollTrigerr
gsap.registerPlugin(ScrollTrigger);
/**
 * 現在一から上スクロールでクラスふよ
 */





/**
 * @desc 一文字づつ文字をラップする
 * @param {*} target 
 * @returns 一文字つづspanでラップしたテキスト
 */
const spanWrapText = (target) => {
  const nodes = [...target.childNodes]; // ノードリストを配列にする
  let returnText = ''; // 最終的に返すテキスト

  for (const node of nodes) {
    if (node.nodeType == 3) {
      //テキストの場合
      const text = node.textContent.replace(/\r?\n/g, ''); //テキストから改行コード削除
      const splitText = text.split(''); // 一文字ずつ分割
      for (const char of splitText) {
        returnText += `<span>${char}</span>`; // spanタグで挟んで連結
      }
    } else {
      returnText += node.outerHTML;
    }
  }
  return returnText;
};


const fadeInEls1 = gsap.utils.toArray('.js-fadein1');
if (fadeInEls1) {
  gsap.fromTo('.js-fadein1', {
    y: 20,
    opacity: 0,
  }, {
    y: 0,
    opacity: 1,
    delay: 1,
    duration: 1,
    stagger: 1
  });

}



const fadeInEls = gsap.utils.toArray('.js-fadein');
if (fadeInEls) {
  fadeInEls.forEach((box, index) => {
    gsap.fromTo(box, {
      y: 60,
      opacity: 0,
    }, {
      y: 0,
      opacity: 1,
      duration: 1.5,
      scrollTrigger: {
        trigger: box,
        start: 'top bottom',
        end: 'bottom top',
      }
    });
  });
}


// const scrollDownToggleClass = new ScrollDownToggleClass(document.getElementById('header'));
// window.addEventListener('scroll', () => {
//   scrollDownToggleClass.toggleClass()
// });




/****/
//

// mv animation

// $(function(){

//   $('.js-toggle').on('click', function(){
//     $(this).toggleClass('is-active')
//     $(this).next().slideToggle()
//   })
// })
/***
 * swiper
 */



const obp = document.querySelector('.bottom-catch-box');
const targ = document.querySelector('.links');
const observer = new IntersectionObserver ((entries) => {
  for (const e of entries) {
      if (e.isIntersecting) {
        targ.classList.add('is-active')
      } else {
        targ.classList.remove('is-active')
      }
  }
});
observer.observe(obp);